import { Directive, effect, ElementRef, inject, input } from '@angular/core';

/**
 * Adds a border to the host element.
 */
@Directive({
	selector: '[lvrBorder]',
})
export class LvrBorderDirective {
	private readonly element = inject(ElementRef);

	public readonly borderWidth = input<number>(1);
	public readonly borderPosition = input<'top' | 'right' | 'bottom' | 'left'>('top');

	public constructor() {
		effect(() => {
			this.setBorder(this.borderWidth(), this.borderPosition());
		});
	}

	private setBorder(width: number, position: 'top' | 'right' | 'bottom' | 'left') {
		// Apply border to the host element
		this.element.nativeElement.style.border = 'none';
		this.element.nativeElement.style[`border${position.charAt(0).toUpperCase() + position.slice(1)}`] =
			`${width}px solid var(--content-border-color)`;
	}
}
